import { PUBLIC_IDM_API_URL_ENV } from 'tools/environments';

import { GetSimpleFooterResponse } from './types';

export const getSimpleFooter = async (lang = 'en') => {
	// `getSimpleFooter` is sometimes executed during Next.js build-time prerender
	// (e.g. `getStaticProps`). If the IDM API base URL isn't configured, `fetch`
	// would try to parse a relative URL and fail the whole build.
	if (!PUBLIC_IDM_API_URL_ENV) {
		console.warn(
			'[getSimpleFooter] NEXT_PUBLIC_IDM_API_URL is empty; returning empty footer.'
		);
		return [];
	}

	try {
		const res = await fetch(
			`${PUBLIC_IDM_API_URL_ENV}/nav/footer?culture=${lang}`,
			{
				method: 'GET',
			}
		);

		if (!res.ok) return [];
		return (await res.json()) as GetSimpleFooterResponse;
	} catch (error) {
		console.error('Get footer request error: ', error);
		return [];
	}
};
